export default "__VITE_ASSET__DnFn$EzT__"